import { useState } from "react";
import "./RecurrenceModal.css";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function RecurrenceModal({ onClose, onSubmit, categories }) {
  const [title, setTitle]           = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority]     = useState("medium");
  const [categoryId, setCategoryId] = useState("");
  const [daysOfWeek, setDaysOfWeek] = useState([]);

  const toggleDay = (day) => {
    setDaysOfWeek(prev =>
      prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day].sort((a, b) => a - b)
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim() || daysOfWeek.length === 0) return;
    onSubmit({
      title:        title.trim(),
      description:  description.trim(),
      priority,
      category_id:  categoryId ? parseInt(categoryId) : null,
      days_of_week: daysOfWeek,
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal recurrence-modal" onClick={e => e.stopPropagation()}>
        <h3>Add Recurring Task</h3>
        <form onSubmit={handleSubmit}>
          <div className="modal-field">
            <label>Task title</label>
            <input
              autoFocus
              placeholder="e.g. Take out trash"
              value={title}
              onChange={e => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="modal-field">
            <label>Description <span className="optional">(optional)</span></label>
            <input
              placeholder="e.g. For Monday pickup"
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </div>

          <div className="modal-field">
            <label>Repeats on</label>
            <div className="day-picker">
              {DAYS.map((day, i) => (
                <button
                  type="button"
                  key={i}
                  className={"day-btn" + (daysOfWeek.includes(i) ? " active" : "")}
                  onClick={() => toggleDay(i)}
                >
                  {day}
                </button>
              ))}
            </div>
          </div>

          <div className="recurrence-selects">
            <div className="modal-field">
              <label>Priority</label>
              <select value={priority} onChange={e => setPriority(e.target.value)}>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </select>
            </div>

            <div className="modal-field">
              <label>Category</label>
              <select value={categoryId} onChange={e => setCategoryId(e.target.value)}>
                <option value="">No category</option>
                {categories.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
            <button
              type="submit"
              className="btn-confirm"
              disabled={!title.trim() || daysOfWeek.length === 0}
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
